import { Mui } from "@osu/react-ui";

function Unsaved({ open, onClose, onConfirm }) {
  return (
    <Mui.Dialog PaperProps={{
      elevation: 15
    }} open={open} onClose={onClose}>
      <Mui.DialogTitle component="h2">Unsaved Selections</Mui.DialogTitle>
      <Mui.DialogContent>
        <Mui.DialogContentText>
          You have links selected that have not been added to your list. Do you
          want to save without them?
        </Mui.DialogContentText>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Button onClick={onClose}>Cancel</Mui.Button>
        <Mui.Button className="margin-left-auto" onClick={onConfirm} variant="contained">
          Save Anyway
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
}

export default Unsaved;
